import React from 'react';
import {StaticImage} from 'gatsby-plugin-image';

function AwardFeature() {
  return <StaticImage src="../images/ai-hackathon-1280.png" alt="AI Hackathon winners" placeholder="blurred" width={640} height={148} />;
}

export default AwardFeature;
